import React from 'react'
import { Typography, makeStyles } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { FormattedDateTime, Tooltip } from 'transfix-ui'
import { FORMATS } from 'constants/datetime'
import { stepsToResolveToResolutionSteps } from '../utils'
import { TResolutionSteps } from './types'

interface IIssueStepsProps {
  steps?: string[] | null
  resolutionSteps?: TResolutionSteps[] | null
}

const useDisplayIssueStepsToResolveStyles = makeStyles(theme => ({
  descriptionContainer: {
    display: 'grid',
    gridTemplateColumns: '24px auto',
    paddingTop: theme.spacing(1),
  },
  textStrike: {
    textDecoration: 'line-through',
  },
}))

export const DisplayIssueStepsToResolve = ({
  resolutionSteps: resolutionStepsProp,
  steps: stepsProp,
}: IIssueStepsProps) => {
  const styles = useDisplayIssueStepsToResolveStyles()
  const steps = stepsProp || []
  const resolutionSteps: TResolutionSteps[] = resolutionStepsProp?.length
    ? resolutionStepsProp
    : stepsToResolveToResolutionSteps(steps)
  const isMpStepsToResolveEnabled = useFeatureFlag('mpStepsToResolve')

  const finalSteps: TResolutionSteps[] = isMpStepsToResolveEnabled
    ? resolutionSteps
    : steps.map((description, index) => ({ description, id: description, stepSequence: index + 1 }))

  return (
    <div>
      {finalSteps.map((step, i: number) => (
        <div key={step.id} className={styles.descriptionContainer}>
          <div>{i + 1}.</div>
          {step.completedAt ? (
            <Tooltip trigger={<div className={styles.textStrike}>{step.description}</div>}>
              Step Updated by {step.completedBy?.fullName}{' '}
              <FormattedDateTime
                inSentence
                showTimezone
                datetime={step.completedAt}
                format='T24TimeWeekdayDateAndYear'
                displayTimezone={FORMATS.defaultTimeZone}
              />
            </Tooltip>
          ) : (
            <div>{step.description}</div>
          )}
        </div>
      ))}
      {finalSteps.length === 0 && (
        <Typography variant='subtitle2' color='textSecondary'>
          No steps to resolve this issue have been added
        </Typography>
      )}
    </div>
  )
}
